import { parseTimeToMinutes } from './appointmentBookingUtils';

const WEEKDAY_ORDER = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export function roundMoney(amount) {
  return Math.round((Number(amount) || 0) * 100) / 100;
}

export function getStoreWeekDayName(dateInput) {
  if (!dateInput) {
    return null;
  }

  const date = typeof dateInput === 'string'
    ? new Date(`${dateInput}T12:00:00`)
    : dateInput;
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return null;
  }

  return WEEKDAY_ORDER[date.getDay() === 0 ? 6 : date.getDay() - 1];
}

function normalizeWeekDay(value) {
  return String(value || '').toLowerCase();
}

function isPercentageAdjustment(type) {
  return type === 1 || String(type || '').toLowerCase() === 'percentage';
}

function periodContainsStart(period, startMinutes) {
  const from = parseTimeToMinutes(period?.from);
  const to = parseTimeToMinutes(period?.to);
  return startMinutes >= from && startMinutes < to;
}

function ruleMatches(rule, weekDayName, startMinutes) {
  const weekDays = (rule?.weekDays || []).map(normalizeWeekDay);
  if (!weekDayName || !weekDays.includes(normalizeWeekDay(weekDayName))) {
    return false;
  }

  if (rule?.allDay) {
    return true;
  }

  return (rule?.periods || []).some((period) => periodContainsStart(period, startMinutes));
}

/**
 * Mirrors AppointmentTimePricingCalculator: extra is based on catalog/service line
 * prices (including membership-covered lines), never the plan fee.
 */
export function calculateAdditionalCostAmount({
  rules = [],
  date,
  startTime,
  serviceLineTotal = 0,
} = {}) {
  const weekDayName = getStoreWeekDayName(date);
  if (!weekDayName || !startTime || !Array.isArray(rules) || rules.length === 0) {
    return 0;
  }

  const startMinutes = parseTimeToMinutes(startTime);
  const rule = rules.find((item) => ruleMatches(item, weekDayName, startMinutes));
  if (!rule) {
    return 0;
  }

  const adjustmentValue = Math.max(0, Number(rule.adjustmentValue) || 0);
  if (adjustmentValue <= 0) {
    return 0;
  }

  if (isPercentageAdjustment(rule.adjustmentType)) {
    return roundMoney(Math.max(0, Number(serviceLineTotal) || 0) * (adjustmentValue / 100));
  }

  return roundMoney(adjustmentValue);
}
